module.exports = __webpack_public_path__ + "img/MNG.c65046f1.svg";